<template>
  <v-dialog v-model="internalDialog" persistent no-click-animation max-width="360" content-class="alert-dialog">
    <v-card>
      <v-card-title class="text-h5">
        {{ title }}
      </v-card-title>
      <v-card-text>
        {{ content }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="closeDialog" :large="$vuetify.breakpoint.mdAndUp">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    dialog: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      internalDialog: this.dialog
    };
  },
  watch: {
    dialog(val) {
      this.internalDialog = val;
    },
    internalDialog(val) {
      this.$emit('dialog-changed', val);
    }
  },
  methods: {
    closeDialog() {
      this.internalDialog = false;
    }
  }
};
</script>

<style>
@media only screen and (min-width: 960px) {
  .alert-dialog .v-card__text {
    font-size: 18px !important;
    text-align: center;
  }
}
</style>